import { RequestStatusFui } from './../../../supplier/models/RequestStatusFui';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Supplier } from 'src/app/components/supplier/models/Supplier';
import Swal from 'sweetalert2';
import { AnreService } from '../../service/anre.service';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-suppliers-fui',
  templateUrl: './suppliers-fui.component.html',
  styleUrls: ['./suppliers-fui.component.scss']
})
export class SuppliersFuiComponent implements OnInit {

  public suppliersFuiForm: FormGroup;
  public cui: string = 'CUI';
  public supplierName: string = 'Denumire furnizor';
  public decision: string = 'Decizie';
  public markAs: string = 'Marchează ca:';
  public supplierOfLastResortNominated: string = 'Furnizor de ultimă instanţă Nominalizat';
  public supplierOfLastResortDesignated: string = 'Furnizor de ultima instanţă Desemnat';
  public startDate: string = 'Dată început';
  public inactivationDate: string = 'Dată inactivare';
  public endDate: string = 'Dată sfârşit';
  public inactivateFui = 'Inactivează calitatea de FUI';
  public inactivateNominated = 'Inactivează calitatea de NOMINALIZAT';
  public saveButtonText = 'Salvează';
  public cancelButtonText = 'Renunţă';
  public decisionNumber = 'Număr decizie';
  public supplier: Supplier;
  public actionType: string;
  public designated: string = 'DESEMNAT';
  public nominated: string = 'NOMINALIZAT';
  public inactiveNominated: string = 'INACTIVE_NOMINALIZAT';
  public reason: string = 'Motiv';
  public isIncativareFui: boolean = false;
  public requestStatusFui: RequestStatusFui;
  public isGas: boolean;
  public isElectricity: boolean;
  public minDate: Date;
  public isNominateFuiSubmitAttempt: boolean = false;

  private subscriptions: Subscription[] = [];

  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private anreService: AnreService
  ) {
    this.supplier = JSON.parse(localStorage.getItem('supplier'));
    this.isGas = !!JSON.parse(localStorage.getItem('isGas'));
    this.requestStatusFui = this.isGas ? this.supplier.fuiGas : this.supplier.fuiElectricity;
    this.isElectricity = !this.isGas;
    if (!this.requestStatusFui) {
      this.requestStatusFui = {} as RequestStatusFui;
    }
    this.actionType = localStorage.getItem('actionType');
    if (this.actionType === 'inactiveazaFui') {
      this.isIncativareFui = true;
    }
    this.minDate = new Date();
    this.minDate.setDate(new Date().getDate());
  }

  ngOnInit(): void {
    this.initSuppliersFuiForm();
    this.onCreateSupplierTypeListeners();

    if ((((this.supplier.fuiTypeElectricityValue === this.designated && this.isElectricity) ||
      (this.supplier.fuiTypeGasValue === this.designated && this.isGas))) && this.isIncativareFui) {
      this.suppliersFuiForm.controls['supplierType'].setValue('invalidateFui');
    }
    if (this.actionType === 'nominalizeazaFui') {
      this.suppliersFuiForm.controls['supplierType'].setValue(this.nominated);
    }
  }

  initSuppliersFuiForm(): void {
    let statusDecisionNumber = this.requestStatusFui?.statusDecisionNumber ?? '';
    const statusChangeReason = this.requestStatusFui?.statusChangeReason ?? '';

    if (this.actionType === 'nominalizeazaFui') {
      statusDecisionNumber = this.isGas ? this.supplier.fuiGasDecisionNumber : this.supplier.fuiElectricityDecisionNumber;
    }

    this.suppliersFuiForm = this.formBuilder.group({
      cui: new FormControl({ value: this.supplier.code, disabled: true }),
      supplierName: new FormControl({ value: this.supplier.name, disabled: true }),
      supplierType: new FormControl({ value: '' }, Validators.required),
      statusDecisionNumber: new FormControl({ value: statusDecisionNumber, disabled: this.actionType === 'nominalizeazaFui' }, Validators.required),
      startDate: new FormControl('', Validators.required),
      endDate: new FormControl(''),
      statusChangeReason: new FormControl(statusChangeReason)
    });
  }

  onCreateSupplierTypeListeners(): void {
    this.subscriptions.push(
      this.suppliersFuiForm.get('supplierType').valueChanges.subscribe(supplierType => {
        if (supplierType === this.nominated) {
          this.suppliersFuiForm.get('endDate').setValidators([Validators.required]);
        } else {
          this.suppliersFuiForm.get('endDate').reset();
          this.suppliersFuiForm.get('endDate').clearValidators();
        }
        this.suppliersFuiForm.controls['endDate'].updateValueAndValidity({ onlySelf: true, emitEvent: false })
      }
      ));
  }

  onChangeFuiStatus(): void {
    this.isNominateFuiSubmitAttempt = true;
    if (!this.suppliersFuiForm.valid) {
      Swal.fire({
        html: `Va rugam sa completati toate campurile`,
        showConfirmButton: true,
        confirmButtonText: 'Ok',
        customClass: {
          popup: 'popup-z-elevate-24-blue'
        }
      });
      return;
    }
    const requestStatusFui: RequestStatusFui = {
      id: this.requestStatusFui.id,
      series: this.isGas ? this.supplier.gasSeries : this.supplier.electricitySeries,
      status: this.suppliersFuiForm.get('supplierType').value === "invalidateFui" ? null :
        this.suppliersFuiForm.get('supplierType').value,
      statusChangeDate: this.suppliersFuiForm.get('startDate').value,
      statusDecisionNumber: this.suppliersFuiForm.get('statusDecisionNumber').value,
      statusChangeReason: this.suppliersFuiForm.get('statusChangeReason').value,
      statusEndDate: this.suppliersFuiForm.get('endDate').value,
      seriesType: this.isGas ? 'CLC' : 'POD'
    } as RequestStatusFui;
    this.anreService.changeRequestStatusFui(requestStatusFui).subscribe(() => {
      return this.router.navigateByUrl('/anre/furnizori');
    }, error => {
      if (error) {
        this.errorNotification(error.error.message);
      }
    });
  }

  onStartDateChanged(event: any): void {
    let date = event.target.value;
    if (!this.isIncativareFui) {
      const selectedDate = moment(date, 'YYYY-MM-DD');
      if (selectedDate.startOf('month').isSame(moment().startOf('month'))) {
        this.suppliersFuiForm.controls['startDate'].setValue(moment().format('YYYY-MM-DD'));
      } else {
        const startDate = moment(date, 'YYYY-MM-DD').startOf('month');
        this.suppliersFuiForm.controls['startDate'].setValue(startDate.format('YYYY-MM-DD'));
      }
    }
  }

  errorNotification(message: string): void {
    Swal.fire({
      title: ' ',
      text: message,
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    });
  }

  onEndDateChanged(event: any): void {
    let date = event.target.value;
    const selectedDate = moment(date, 'YYYY-MM-DD');
    const endDate = moment(selectedDate, 'YYYY-MM-DD').endOf('month');
    this.suppliersFuiForm.controls['endDate'].setValue(endDate.format('YYYY-MM-DD'));
  }

  onDisplayRequiredField(field: string): any {
    return {
      'input-required': !this.isFieldValid(field) && this.isNominateFuiSubmitAttempt,
    };
  }

  isFieldValid(field: string): boolean {
    return this.suppliersFuiForm.get(field).valid;
  }

  onCancel(): void {
    history.back();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

}
